// extracted by mini-css-extract-plugin
module.exports = {"btnOrange":"OrangeBtn_btnOrange__1FzK1"};